export enum PublisherConfigPlaceholder {
    DoubleserveConfig = "{{config}}"
}
